var render, staticRenderFns
import script from "./TruckWeightCapacity.vue?vue&type=script&lang=js"
export * from "./TruckWeightCapacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7356dc",
  null
  
)

export default component.exports